import {get} from "lodash"
import BaseService from "./Base"
import {CalendarGroups} from "types/calendar-groups"

class CalendarGroupsService extends BaseService {
    async getAll(data: any = {}): Promise<{data: CalendarGroups.CalendarGroup[]; total: number}> {
        const response = await this.post("/calendar-groups/list", data)
        return get(response, "data", [])
    }

    async getDetails(calendarGroupId: number): Promise<CalendarGroups.CalendarGroup | null> {
        const response = await this.post("/calendar-groups/details", {calendarGroupId})
        return get(response, "data.data", get(response, "data", null))
    }

    async createCalendarGroup(data: CalendarGroups.CreateCalendarGroupPayload): Promise<CalendarGroups.CalendarGroup> {
        const response = await this.post("/calendar-groups/create", data)
        return get(response, "data.data", get(response, "data", {}))
    }

    async updateCalendarGroup(data: CalendarGroups.UpdateCalendarGroupPayload): Promise<CalendarGroups.CalendarGroup> {
        const response = await this.post("/calendar-groups/edit", data)
        return get(response, "data.data", get(response, "data", {}))
    }

    async refreshCalendarGroup(calendarGroupId: number): Promise<boolean> {
        const response = await this.post("/calendar-groups/refresh", {calendarGroupId})
        return get(response, "data.data", get(response, "data", {}))
    }

    async deleteCalendarGroup(calendarGroupIds: number[]): Promise<void> {
        const response = await this.post("/calendar-groups/delete", {calendarGroupIds})
        return get(response, "data", {})
    }

    async getCalendarGroupMembers(
        payload: CalendarGroups.GetCalendarGroupMembersPayload
    ): Promise<{data: CalendarGroups.CalendarGroupMember[]; total: number}> {
        const response = await this.post("/calendar-groups/members", payload)
        return get(response, "data", {data: [], total: 0})
    }
}

export default CalendarGroupsService
